import styled from "styled-components"

import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"

const SectionContent = styled.div`
  padding: 0 20px;
  margin-bottom: 20px;
`

const SummaryText = styled.p`
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0 0 8px;
  line-height: 1.6;
`

const BulletList = styled.ul`
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
`

const BulletItem = styled.li`
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.7;
  margin-bottom: 4px;
`

const LoadingText = styled.p`
  font-size: 14px;
  color: var(--text-disabled);
  margin: 0;
  padding: 8px 0;
`

interface Props {
  isLoading: boolean
  bullets: string[]
}

export const SummarySection = ({ isLoading, bullets }: Props) => (
  <>
    <ModalSectionTitle title="Summary" />
    <SectionContent>
      {isLoading ? (
        <LoadingText>Loading...</LoadingText>
      ) : bullets.length > 0 ? (
        <>
          <SummaryText>Overall, the system:</SummaryText>
          <BulletList>
            {bullets.map((item, index) => (
              <BulletItem key={index}>{item}</BulletItem>
            ))}
          </BulletList>
        </>
      ) : (
        <SummaryText>No summary available.</SummaryText>
      )}
    </SectionContent>
  </>
)
